import { render, staticRenderFns } from "./InstitutionScheduleTable.vue?vue&type=template&id=e79b2562"
import script from "./InstitutionScheduleTable.vue?vue&type=script&lang=js"
export * from "./InstitutionScheduleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports